import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12","key":"svg-0"}],["path",{"d":"M10 4l4 16","key":"svg-1"}],["path",{"d":"M12 12l-8 2","key":"svg-2"}]]

const IconLayoutCollage = createReactComponent('outline', 'layout-collage', 'LayoutCollage', __iconNode);

export default IconLayoutCollage;